import { HEROKU_ID_KEY, TRAILER_CARE_TYPE } from 'types'
import { convertDollarsToCents } from 'utils'

const apiValuesForTrailerCareUpgrade = ({
  account,
  billing,
  membership,
  selectedTrailerCareType,
}) => {
  const { trailerCareCost: total_cost } = billing
  const membership__c = {
    [HEROKU_ID_KEY]: membership[HEROKU_ID_KEY],
  }

  const isUpgrade = !!membership?.trailer_care_type__c
  const upgradeFields = isUpgrade
    ? {
      upgrading_from: TRAILER_CARE_TYPE.BASIC,
      upgrading_to: TRAILER_CARE_TYPE.PLUS,
    }
    : {
      trailer_care_type: selectedTrailerCareType,
    }

  const basePayload = {
    membership__c,
    account__c: {
      [HEROKU_ID_KEY]: account[HEROKU_ID_KEY],
    },
    ...upgradeFields,
  }

  const { stripeCustomerId, stripePaymentIntentId, stripePaymentMethodId } =
    billing
  const payload = {
    ...basePayload,
    stripe_customer_id: stripeCustomerId,
    stripe_payment_intent_id: stripePaymentIntentId,
    stripe_payment_method_id: stripePaymentMethodId,
    total_cost: convertDollarsToCents(total_cost),
  }

  return payload
}

export default apiValuesForTrailerCareUpgrade
